/**
 *
 * @param {HTMLElement | null} root
 * @param {string | NodeList} selector
 * @param {Function} callback
 */
export default function startExposeObserve(
  root: HTMLElement | null,
  selector: string | NodeList,
  callback: Function,
  name = 'key'
) {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: [0, 0.9, 1.0],
  }

  /** 缓存 key, 用来过滤被频繁调用 */
  let keyStacks = [] as string[]
  /** @type {IntersectionObserver} */
  const observer = new IntersectionObserver(intersectionObserverHandler, options)

  let elements
  if (selector instanceof NodeList) {
    elements = selector instanceof NodeList ? selector : []
  } else {
    const el = Object.prototype.hasOwnProperty.call(root || {}, 'querySelectorAll') ? root : document
    elements = el!.querySelectorAll(selector)
  }
  elements.forEach(item => {
    observer.observe(item as Element)
  })

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  function intersectionObserverHandler(entries: IntersectionObserverEntry[]) {
    entries.forEach(entry => {
      const { target, intersectionRatio } = entry
      if (target) {
        const exposeKey = ((target as HTMLElement).dataset || {})[name]
        if (intersectionRatio <= 0) {
          keyStacks = keyStacks.filter(v => v !== exposeKey)
        } else {
          if (exposeKey && !keyStacks.includes(exposeKey)) {
            if (typeof callback === 'function') {
              callback(exposeKey)
            }
            keyStacks.push(exposeKey)
          }
        }
      }
    })
  }

  /**
   * 销毁函数
   * @param {Element} [target]
   */
  return (target: Element) => {
    if (target) {
      observer.unobserve(target)
    } else {
      observer.disconnect()
    }
  }
}
